/**
 * Image Canvas
 *
 * Canvas helpers for image rotation and bitmap transforms.
 */

class ImageCanvas {
    public static rotateImage(img: HTMLImageElement, degrees: number): string {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            return "";
        }

        const radians = (degrees * Math.PI) / 180;
        const cos = Math.abs(Math.cos(radians));
        const sin = Math.abs(Math.sin(radians));

        const newWidth = img.width * cos + img.height * sin;
        const newHeight = img.width * sin + img.height * cos;

        canvas.width = newWidth;
        canvas.height = newHeight;

        ctx.translate(newWidth / 2, newHeight / 2);
        ctx.rotate(radians);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);

        return canvas.toDataURL("image/jpeg", 0.9);
    }

    public static drawWithOrientation(img: HTMLImageElement, orientation: number, maxW: number, maxH: number): string {
        const iw = img.naturalWidth || img.width;
        const ih = img.naturalHeight || img.height;
        const swap = orientation >= 5 && orientation <= 8;
        const ow = swap ? ih : iw;
        const oh = swap ? iw : ih;
        maxW = maxW || 1600;
        maxH = maxH || 1600;
        const scale = Math.min(1, Math.min(maxW / ow, maxH / oh));
        const cw = Math.max(1, Math.round(ow * scale));
        const ch = Math.max(1, Math.round(oh * scale));

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            return "";
        }
        canvas.width = cw;
        canvas.height = ch;

        const dw = Math.max(1, Math.round(iw * scale));
        const dh = Math.max(1, Math.round(ih * scale));

        ctx.save();
        switch (orientation) {
            case 2:
                ctx.translate(cw, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                ctx.translate(cw, ch);
                ctx.rotate(Math.PI);
                break;
            case 4:
                ctx.translate(0, ch);
                ctx.scale(1, -1);
                break;
            case 5:
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -cw);
                break;
            case 7:
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-ch, 0);
                ctx.scale(1, -1);
                break;
            case 8:
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-ch, 0);
                break;
            default:
                break;
        }

        ctx.drawImage(img, 0, 0, dw, dh);
        ctx.restore();
        return canvas.toDataURL("image/jpeg", 0.9);
    }
}

export { ImageCanvas };
